import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';

export const StyledReferringPhysicianGuidelinesTextareaField = styled(Textarea)`
   height: 100px;
`;
